var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTotalVolumnLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    rx: 16,
    fill: "url(#paint0_linear_11114_52191)",
    fillOpacity: 0.15
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 15.5,
    stroke: "#0D1A16",
    strokeOpacity: 0.07
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.666,
    y: 24,
    width: 3,
    height: 21,
    fill: "#02B27F"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.666,
    y: 29,
    width: 3,
    height: 16,
    fill: "#02B27F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 32.666,
    y: 22,
    width: 3,
    height: 23,
    fill: "#02B27F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 40.666,
    y: 18,
    width: 3,
    height: 27,
    fill: "#F2AE00"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_11114_52191",
    x1: 9,
    y1: 2,
    x2: 60,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03F5AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03F5AE",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalVolumnLight);
export default __webpack_public_path__ + "static/media/totalVolumnLight.9ec9c7d89bf833ac6dad55d06c379029.svg";
export { ForwardRef as ReactComponent };